const finance = [
	{
		path: '/network/finance/overview',
		name: 'network-finance-overview',
		component: () => import('@/views/network/finance/overview.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/finance/liabilities',
		name: 'network-finance-liabilities',
		component: () => import('@/views/network/finance/liabilities.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/finance/execution-mode',
		name: 'network-finance-execution-mode',
		component: () => import('@/views/network/finance/execution-mode.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/finance/payouts',
		name: 'network-finance-payouts',
		component: () => import('@/views/network/finance/payouts.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
]

export default finance
